import React from 'react';
import { func, bool, string, arrayOf } from 'prop-types';
import styled from 'styled-components';
import { length } from 'redux-form-validators';

import { Form, Button, Input, Checkbox } from 'semantic-ui-react';

import CommonForm from '~/views/common/Form';
import FormField from '~/views/common/FormField';

import { fmt } from '~/utils';


const Container = styled.div`
    display: inline-flex;
    flex-direction: column;
`;

const StyledForm = styled(CommonForm)`
    min-width: 400px;
`;


const SearchForm = ({
    pristine,
    submitting,
    invalid,
    filters = [],
    handleReset,
    placeholder = 'Keyword',
    systemPortalList,
    handleClearSystemPortalList,
    ...rest
}) => (
    <Container>
        <StyledForm submitting={submitting} {...rest}>
            <FormField
                name="terms"
                control={Input}
                validate={length({ min: 3 })}
                placeholder={placeholder}
                icon="search"
                iconPosition="left"
            />

            { !!filters.length && (
                <Form.Group>
                    { filters.map(field => (
                        <FormField
                            key={field}
                            name={field}
                            control={Checkbox}
                            label={fmt(field)}
                        />
                    )) }
                </Form.Group>
            ) }

            <Button.Group>
                <Button
                    disabled={pristine || submitting || invalid}
                    loading={submitting}
                    type="submit"
                    content="Search"
                    primary
                />
                { systemPortalList ?
                    <Button
                        onClick={handleClearSystemPortalList}
                        disabled={pristine || submitting}
                        content="Clear"
                        type="button"
                    />
                    :
                    <Button
                        onClick={handleReset}
                        disabled={pristine || submitting}
                        content="Clear"
                        type="button"
                    />
                }
            </Button.Group>
        </StyledForm>
    </Container>
);


SearchForm.propTypes = {
    submitting: bool.isRequired,
    pristine: bool.isRequired,
    invalid: bool.isRequired,
    placeholder: string,
    handleReset: func.isRequired,
    filters: arrayOf(string.isRequired),
    systemPortalList: bool,
    handleClearSystemPortalList: func,
};

export default SearchForm;
